import Vue from 'vue'
import { Api } from 'api'
import { cloneDeep, sortBy } from 'lodash'

const state = {
  globalConfig: {
    layoutName: '', // 布局名称
    layoutDesc: '' // 对象描述
  },
  platformType: 0, // 移动端还是pc端
  selectedComponent: null, // 选中的组件
  selectedMobileComponent: null, // 选中的移动端组件
  activeComponent: null, // 激活的组件
  inUsedComponent: [], // 已使用的组件
  displayComponent: {}, // 展示的组件
  displayComponentClone: {}, // 展示的组件
  fieldList: [], // 字段列表
  fieldClassifyInfo: {}, // 字段分类信息
  updateComponent: ''
}

function updateAimComponent(collection, code, component) {
  state.updateComponent =  code + '_' + new Date().getTime()
  if (Object.hasOwnProperty.call(collection, 'childList')) {
    Array.isArray(collection.childList) && collection.childList.some((item) => {
      if (item['code'] === code) {
        if (state.platformType === 0) {
          if (item.config && item.config.indexOf('Pc') > -1) {
            Vue.set(item, 'properties', component)
            return true
          }
        } else {
          if (item.config && item.config.indexOf('Mobile') > -1) {
            Vue.set(item, 'properties', component)
            return true
          }
        }
      }
      if (Array.isArray(item.childList)) {
        updateAimComponent(item, code, component)
      }
    })
  } else {
    Array.isArray(collection.childList || collection['top']?.childList) && collection['top']?.childList.some((item) => {
      if (item['code'] === code) {
        if (state.platformType === 0) {
          if (item.config && item.config.indexOf('Pc') > -1) {
            Vue.set(item, 'properties', component)
            return true
          }
        } else {
          if (item.config && item.config.indexOf('Mobile') > -1) {
            Vue.set(item, 'properties', component)
            return true
          }
        }
      }
      if (Array.isArray(item.childList)) {
        updateAimComponent(item, code, component)
      }
    })
    Array.isArray(collection.childList || collection['left']?.childList) && collection['left']?.childList.some((item) => {
      if (item['code'] === code) {
        if (state.platformType === 0) {
          if (item.config && item.config.indexOf('Pc') > -1) {
            Vue.set(item, 'properties', component)
            return true
          }
        } else {
          if (item.config && item.config.indexOf('Mobile') > -1) {
            Vue.set(item, 'properties', component)
            return true
          }
        }
      }
      if (Array.isArray(item.childList)) {
        updateAimComponent(item, code, component)
      }
    })
    Array.isArray(collection.childList || collection['right']?.childList) && collection['right']?.childList.some((item) => {
      if (item['code'] === code) {
        if (state.platformType === 0) {
          if (item.config && item.config.indexOf('Pc') > -1) {
            Vue.set(item, 'properties', component)
            return true
          }
        } else {
          if (item.config && item.config.indexOf('Mobile') > -1) {
            Vue.set(item, 'properties', component)
            return true
          }
        }
      }
      if (Array.isArray(item.childList)) {
        updateAimComponent(item, code, component)
      }
    })
    Array.isArray(collection.childList || collection['bottom']?.childList) && collection['bottom']?.childList.some((item) => {
      if (item['code'] === code) {
        if (state.platformType === 0) {
          if (item.config && item.config.indexOf('Pc') > -1) {
            Vue.set(item, 'properties', component)
            return true
          }
        } else {
          if (item.config && item.config.indexOf('Mobile') > -1) {
            Vue.set(item, 'properties', component)
            return true
          }
        }
      }
      if (Array.isArray(item.childList)) {
        updateAimComponent(item, code, component)
      }
    })
    Array.isArray(collection.childList || collection['form']?.childList) && collection['form']?.childList.some((item) => {
      if (item['code'] === code) {
        if (state.platformType === 0) {
          if (item.config && item.config.indexOf('Pc') > -1) {
            Vue.set(item, 'properties', component)
            return true
          }
        } else {
          if (item.config && item.config.indexOf('Mobile') > -1) {
            Vue.set(item, 'properties', component)
            return true
          }
        }
      }
      if (Array.isArray(item.childList)) {
        updateAimComponent(item, code, component)
      }
    })
  }
}
function deleteAimComponent(collection, code) {
  if (Object.hasOwnProperty.call(collection, 'childList')) {
    let aimIndex
    Array.isArray(collection.childList) && collection.childList.some((item, index) => {
      if (item['code'] === code) {
        aimIndex = index
        return true
      }
      if (Array.isArray(item.childList)) {
        deleteAimComponent(item, code)
      }
    })
    if (aimIndex > -1) {
      collection.childList.splice(aimIndex, 1)
    }
  } else {
    let aimTopIndex
    Array.isArray(collection.childList || collection['top']?.childList) && collection['top']?.childList.some((item, index) => {
      if (item['code'] === code) {
        aimTopIndex = index
        return true
      }
      if (Array.isArray(item.childList)) {
        deleteAimComponent(item, code)
      }
    })
    if (aimTopIndex > -1) {
      collection['top']?.childList.splice(aimTopIndex, 1)
    }
    let aimLeftIndex
    Array.isArray(collection.childList || collection['left']?.childList) && collection['left']?.childList.some((item, index) => {
      if (item['code'] === code) {
        aimLeftIndex = index
        return true
      }
      if (Array.isArray(item.childList)) {
        deleteAimComponent(item, code)
      }
    })
    if (aimLeftIndex > -1) {
      collection['left']?.childList.splice(aimLeftIndex, 1)
    }
    let aimRightIndex
    Array.isArray(collection.childList || collection['right']?.childList) && collection['right']?.childList.some((item, index) => {
      if (item['code'] === code) {
        aimRightIndex = index
        return true
      }
      if (Array.isArray(item.childList)) {
        deleteAimComponent(item, code)
      }
    })
    if (aimRightIndex > -1) {
      collection['right']?.childList.splice(aimRightIndex, 1)
    }
    let aimBottomIndex
    Array.isArray(collection.childList || collection['bottom']?.childList) && collection['bottom']?.childList.some((item, index) => {
      if (item['code'] === code) {
        aimBottomIndex = index
        return true
      }
      if (Array.isArray(item.childList)) {
        deleteAimComponent(item, code)
      }
    })
    if (aimBottomIndex > -1) {
      collection['bottom']?.childList.splice(aimBottomIndex, 1)
    }
    let aimFormIndex
    Array.isArray(collection.form && collection.form.childList) && collection.form.childList.some((item, index) => {
      if (item['code'] === code) {
        aimFormIndex = index
        return true
      }
      if (Array.isArray(item.childList)) {
        deleteAimComponent(item, code)
      }
    })
    if (aimFormIndex > -1) {
      collection.form.childList.splice(aimFormIndex, 1)
    }
  }
}
const mutations = {
  UPDATE_PLATFORM_TYPE(state, vo) {
    state.selectedMobileComponent = null
    state.selectedComponent = null
    state.activeComponent = null
    state.inUsedComponent = []
    state.platformType = vo
  },

  ACTIVE_COMPONENT(state, vo) {
    state.activeComponent = vo
  },
  INIT_PAGE_INFO(state, vo) {
    state.displayComponent = vo
    state.isUsedComponent = []
    state.selectedComponent = null
    state.selectedMobileComponent = null
    state.activeComponent = null
  },
  RESET_STATE(state) {
    state.selectedComponent = null
    state.selectedMobileComponent = null
    state.activeComponent = null
    state.inUsedComponent = []
    state.displayComponent = {}
  },
  CURRENT_CONFIG_COMPONENT(state, vo) {
    if (state.platformType === 0) {
      state.selectedComponent = vo && vo.component || null
    } else {
      state.selectedMobileComponent = vo && vo.component || null
    }
    const obj = vo && vo.component || null
    if (obj) {
      let showFieldParam = []
      if (vo.layoutCode === 'detail') {
        showFieldParam = (obj && obj.properties && obj.properties.showFieldParam) || []
      } else {
        const temp = (obj && obj.properties && obj.properties.showFieldParam) || []
        if (!['back', 'offer'].includes(vo.objectCode)) {
          showFieldParam = temp.filter(item => item.instanceGroupEn !== 'sys')
        } else {
          if(obj.code === 'OfferResumeInfoForm'){
            showFieldParam = temp.filter(item => item.instanceGroupEn !== 'sys' || ['resume_00015', 'resume_00320'].includes(item.instanceCode))
          }else{
            showFieldParam = temp
          }
        }
      }
      let arr = []
      if (vo.objectCode === 'resume') {
        switch (obj.code) {
          case 'ResumeBasicInfo':
          case 'ResumeJobPretend':
          case 'ResumeHeadForm':
          case 'ResumeBaseForm':
          case 'ResumeJobPretendForm':
          case 'ResumeFileListForm':
          case 'TopInfo':
            // 基本信息&求职意向&简历头部信息&简历基本信息表单&求职意向表单&附件列表表单
            arr = state.fieldClassifyInfo?.resume
            break
          case 'ResumeEduExperience':
          case 'ResumeEduExperienceForm':
            // 教育经历
            arr = state.fieldClassifyInfo?.['resume_education']
            break
          case 'ResumeWorkExperienceForm':
            // 工作经历表单
            arr = state.fieldClassifyInfo?.['resume_work']
            break
          case 'ResumeProjectExperienceForm':
            // 项目经历表单
            arr = state.fieldClassifyInfo?.['resume_project']
            break
          case 'ResumeSkillListForm':
            // 技能表单
            arr = state.fieldClassifyInfo?.['resume_skill']
            break
          case 'ResumeLanguageListForm':
            // 语言表单
            arr = state.fieldClassifyInfo?.['resume_skill_language']
            break
        }
      } else if (vo.objectCode === 'job') {
        arr = state.fieldClassifyInfo?.['job']
      } else if (vo.objectCode === 'offer') {
        switch (obj.code) {
          case 'OfferResumeInfo':
          case 'OfferResumeInfoForm':
            // 简历基本信息
            arr = state.fieldClassifyInfo?.['resume']
            break
          case 'OfferPositionInfo':
          case 'OfferPositionInfoForm':
            // 职位基本信息
            arr = state.fieldClassifyInfo?.['job']
            break
          default:
            arr = state.fieldClassifyInfo?.['offer']
            break
        }
      } else if (vo.objectCode === 'back') {
        switch (obj.code) {
          case 'InvestigateTopInfo':
            // 顶部信息
            arr = state.fieldClassifyInfo?.['back']
            break
          case 'InvestigateResumeInfo':
          case 'InvestigateResumeInfoForm':
            // 简历基本信息
            arr = state.fieldClassifyInfo?.['resume']
            break
          case 'InvestigatePositionInfo':
          case 'InvestigatePositionInfoForm':
            // 职位基本信息
            arr = state.fieldClassifyInfo?.['job']
            break
          case 'InvestigateInfo':
          case 'InvestigateInfoForm':
            // 背调信息
            arr = state.fieldClassifyInfo?.['back_work']
            break
          case 'InvestigateFileInfo':
          case 'InvestigateFileInfoForm':
            // 背调附件
            arr = state.fieldClassifyInfo?.['back']
            break
        }
      }
      let list = []
      if (vo.layoutCode === 'detail') {
        if (['resume', 'job'].includes(vo.objectCode)) {
          list = arr.filter(item => {
            return item.id !== showFieldParam.find(info => info.id === item.id)?.id
          })
        } else if (['back', 'offer'].includes(vo.objectCode)) {
          list = arr.filter(item => {
            if (['back', 'offer'].includes(vo.objectCode)) {
              if (item.objectCode === 'resume') {
                return item.id !== showFieldParam.find(info => info.id === item.id)?.id
              } else {
                return item.id !== showFieldParam.find(info => info.id === item.id)?.id && item.instanceGroupEn !== 'sys'
              }
            }
          })
        }
      } else {
        list = arr.filter(item => {
          if (['back', 'offer'].includes(vo.objectCode)) {
            if (item.objectCode === 'resume') {
              if(vo.component.code === 'OfferResumeInfoForm'){
                // offer 的 基本信息特殊处理  除了 年龄 resume_00015,应聘职位 resume_00320  其他系统字段都过滤
                return item.id !== showFieldParam.find(info => info.id === item.id)?.id && (item.instanceGroupEn !== 'sys' || ['resume_00015', 'resume_00320'].includes(item.instanceCode))
              }else{
                return item.id !== showFieldParam.find(info => info.id === item.id)?.id
              }
            } else {
              return item.id !== showFieldParam.find(info => info.id === item.id)?.id && item.instanceGroupEn !== 'sys'
            }
          } else {
            return item.id !== showFieldParam.find(info => info.id === item.id)?.id && item.instanceGroupEn !== 'sys'
          }
        })
      }
      let showList = []      
      if(vo.layoutCode === 'addOrEdit' && ['back', 'offer'].includes(vo.objectCode)){
        showList = list.filter(item => item['instanceFix'] === 1 && item.instanceCode !== 'resume_00320') // fixbug 247333  临时处理
      }else{
        if(obj.code === 'TopInfo'){
          const tmpList = list.filter(item => ['resume_00065', 'resume_00505', 'resume_00506', 'resume_00508', 'resume_00725'].includes(item['instanceCode']))
          showList = sortBy(tmpList, 'instanceCode');
        }else{
          showList = list.filter(item => item['instanceFix'] === 1)
        }
      }
      if (showList.length) {
        showList.map(item => {
          const index = list.findIndex(info => info.id === item.id)
          if (index > -1) {
            list.splice(index, 1)
          }
        })
      }
      if (state.platformType === 0) {
        state.selectedComponent.config = 'CustomTabsConfigPc'
        let exposeButtonNum = 1
        if (vo.layoutCode === 'detail') {
          exposeButtonNum = 4
        } else {
          exposeButtonNum = 2
        }
        if (!state.selectedComponent?.properties?.exposeButtonNum) {
          const obj = {
            properties: {
              exposeButtonNum: exposeButtonNum
            }
          }
          state.selectedComponent = Object.assign(state.selectedComponent, obj)
        }
        state.selectedComponent.properties = {
          ...state.selectedComponent.properties,
          hideFieldParam: list,
          showFieldParam: showFieldParam.length ? showFieldParam : showList
        }
      } else {
        state.selectedMobileComponent.config = 'CustomTabsConfigMobile'
        if (!state.selectedMobileComponent?.properties?.exposeButtonNum) {
          const obj = {
            properties: {
              exposeButtonNum: 1
            }
          }
          state.selectedMobileComponent = Object.assign(state.selectedMobileComponent, obj)
        }
        state.selectedMobileComponent.properties = {
          ...state.selectedMobileComponent.properties,
          hideFieldParam: list,
          showFieldParam: showFieldParam.length ? showFieldParam : showList
        }
      }
    }
  },

  SET_DISPLAY_MODULE(state, vo) {
    const { moduleName, data } = vo
    if (state.displayComponent[moduleName]) {
      state.displayComponent[moduleName].childList = data
    }
  },

  INIT_DISPLAY_MODULE(state, vo) {
    state.displayComponent = vo
    state.displayComponentClone = cloneDeep(state.displayComponent)
  },

  DELETE_AIM_COMPONENT(state, vo) {
    Object.keys(state.displayComponent).forEach((key) => {
      deleteAimComponent(state.displayComponent[key], vo)
    })
  },

  SET_FIELD_LIST(state, vo) {
    state.fieldList = vo
  },

  // 全部设置 两个字段更新
  UPDATE_LAYOUT_GLOBAL_CONFIG(state, val) {
    state.globalConfig = { ...state.globalConfig, ...val }
  },

  // 表单布局展示列
  CHANGE_EXPOSE_BUTTON_BUM(state, val) {
    if (state.platformType === 0) {
      state.selectedComponent.properties.exposeButtonNum = val
    } else {
      state.selectedMobileComponent.properties.exposeButtonNum = val
    }
  },

  // 新增/编辑表单配置数据更新
  UPDATE_CONFIG_FIELD_LIST(state, val) {
    const [hideFieldParam, showFieldParam] = val || []
    if (state.platformType === 0) {
      state.selectedComponent.properties = { ...state.selectedComponent.properties, hideFieldParam, showFieldParam }
      Object.keys(state.displayComponent).forEach((key) => {
        console.log('dis===', state.displayComponent[key])
        if (key === 'pc') {
          updateAimComponent(state.displayComponent[key], state.selectedComponent.code, state.selectedComponent.properties)
        }
      })
    } else {
      state.selectedMobileComponent.properties = { ...state.selectedMobileComponent.properties, hideFieldParam, showFieldParam }
      Object.keys(state.displayComponent).forEach((key) => {
        console.log('dis1===', state.displayComponent[key])
        if (key === 'mobile') {
          updateAimComponent(state.displayComponent[key], state.selectedMobileComponent.code, state.selectedMobileComponent.properties)
        }
      })
    }
  },
  // 初始化模块字段
  INIT_MODULE_FIELD_LIST(state, list) {
    state.fieldList = list
  },
  // 查询字段（按分类）
  INIT_CLASSIFY_FIELD_LIST(state, vo) {
    state.fieldClassifyInfo = vo
  },

  // 合并初始化表单信息
  INIT_ADD_OR_EDIT_CONFIG() {
  }
}

const actions = {
  initPageInfo({ commit }, vo) {
    commit('INIT_PAGE_INFO', vo)
  },
  setCurrentConfigComponent({ commit }, vo) {
    commit('CURRENT_CONFIG_COMPONENT', vo)
  },
  setDisplayModule({ commit }, vo) {
    commit('SET_DISPLAY_MODULE', vo)
  },
  deleteAimComponent({ commit }, vo) {
    commit('DELETE_AIM_COMPONENT', vo)
    commit('CURRENT_CONFIG_COMPONENT', null)
  },
  activeComponent({ commit }, vo) {
    commit('ACTIVE_COMPONENT', vo)
  },
  setFieldList({ commit }, vo) {
    commit('SET_FIELD_LIST', vo)
  },
  setTabConfig({ commit }, vo) {
    commit('SET_TAB_CONFIG', vo)
  },

  async getAllFieldsByView({ commit }, vo) {
    await Api.getAllFieldsByView(vo).then(res => {
      if (res && res.code === '0') {
        const list = (res.data || []).filter(v => !v.disabled)
        commit('INIT_MODULE_FIELD_LIST', list)
      }
    })
  },
  async listFieldsClassify({ commit }, vo) {
    await Api.listFieldsClassify(vo).then(res => {
      if (res && res.code === '0') {
        commit('INIT_CLASSIFY_FIELD_LIST', res.data)
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
